import { ShortUrl } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSessionIdAction } from '~/store/boardCollection/actions';
import { boardCollectionFormSelector, boardCollectionSessionIdSelector } from '~/store/boardCollection/selectors';
import { useAirStore } from '~/utils/ReduxUtils';

export function useGetBoardCollectionSessionId() {
  const dispatch = useDispatch();
  const store = useAirStore();
  const { shortId } = useShortIdContext();
  const form = useSelector(boardCollectionFormSelector);

  const getSessionId = useCallback(async () => {
    let sessionId = boardCollectionSessionIdSelector(store.getState());

    if (!sessionId) {
      const { id } = await ShortUrl.createFormSession({ shortId, formId: form.id });

      dispatch(setSessionIdAction({ sessionId: id }));

      sessionId = id;
    }

    return { sessionId };
  }, [dispatch, form, shortId, store]);

  return { getSessionId };
}
